// extracted by mini-css-extract-plugin
export default {"ads":"ads_ads__Uip75","btn":"ads_btn__+HITn","mobileBtn":"ads_mobileBtn__1G69c","table":"ads_table__-fnTh"};